define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaStatusDomain = void 0;
    class WaStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaStatusDomain.Draft, value: "Draft" },
                    { key: WaStatusDomain.PendingApprovalLga, value: "Pending Approval (LGA)" },
                    { key: WaStatusDomain.Finalised, value: "Finalised" },
                    { key: WaStatusDomain.Refused, value: "Refused" },
                    { key: WaStatusDomain.Terminated, value: "Terminated" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaStatusDomain.Draft] = 0;
                this.KeyIndex[WaStatusDomain.PendingApprovalLga] = 1;
                this.KeyIndex[WaStatusDomain.Finalised] = 2;
                this.KeyIndex[WaStatusDomain.Refused] = 3;
                this.KeyIndex[WaStatusDomain.Terminated] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Draft"] = 0;
                this.ValueIndex["Pending Approval (LGA)"] = 1;
                this.ValueIndex["Finalised"] = 2;
                this.ValueIndex["Refused"] = 3;
                this.ValueIndex["Terminated"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaStatusDomain = WaStatusDomain;
    Object.defineProperty(WaStatusDomain, "Draft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(WaStatusDomain, "PendingApprovalLga", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PA"
    });
    Object.defineProperty(WaStatusDomain, "Finalised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "A"
    });
    Object.defineProperty(WaStatusDomain, "Refused", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "R"
    });
    Object.defineProperty(WaStatusDomain, "Terminated", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "T"
    });
    Object.defineProperty(WaStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
